import { isFunction } from 'lodash'
import moment from 'moment'

import { HtmlEntities } from '@wf-sl/common-utilities'

import { THROW_INTL_ERROR_MESSAGE } from '../constants'
import { isCurrentYear } from '../validator/is-current-year'
import { isCurrentYearUTC } from '../validator/is-current-year-utc'
import { isValidISO8601 } from '../validator/is-valid-iso-8601'

/**
 * @deprecated As this method has many performance issues, please use {@link formatIso8601String}, if appropriate.
 * Otherwise create another function based on {@link formatIso8601String} which fit's your needs!
 *
 * This function distinguish between this year, today and others.
 * If it is the current year, it will returned without the year.
 * If `preserveDate` is true the date will always be included.
 *
 * @param {Intl} intl - Global modux intl helper.
 * @param {string} date - The date to be parsed.
 * @param {boolean} [useUTC=false] - If true the date is used as a UTC time
 * @returns {string} Returns a string with the formatted date and time or a mdash
 */
export function formatDateOnly(intl, date, useUTC = false) {
    if (!intl || !isFunction(intl.formatDate)) {
        throw new Error(THROW_INTL_ERROR_MESSAGE)
    }

    let givenDate = null

    if (isValidISO8601(date)) {
        givenDate = moment(date).toDate()
    } else {
        return HtmlEntities.MDASH
    }

    if (!useUTC) {
        return intl.formatDate(givenDate, isCurrentYear(givenDate) ? 'dateWoYear' : 'defaultDate')
    }
    return intl.formatDate(givenDate, isCurrentYearUTC(givenDate) ? 'dateWoYearUTC' : 'UTCDate')
}
